import React from "react";
import { ESTADOS_FORMACION } from "../constants/estadosFormacion";

export default function FormacionesFilters({
  filtros,
  setFiltros,
  limpiarFiltros,
  promocionesOptions = [],
  promocionesLoading = false,
}) {
  return (
    <div className="management-card formaciones-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-3">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="search"
            className="form-control"
            placeholder="Estudiante, matrícula o estado"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Activo</label>
          <select
            className="form-select"
            value={filtros.activo}
            onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Promoción</label>
          <select
            className="form-select"
            value={filtros.promocion}
            onChange={(e) => setFiltros((prev) => ({ ...prev, promocion: e.target.value }))}
            disabled={promocionesLoading}
          >
            {promocionesLoading ? (
              <option value="all">Cargando...</option>
            ) : (
              <>
                <option value="all">Todas</option>
                <option value="none">Sin promoción</option>
                {promocionesOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Estado</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.estado}
              onChange={(e) => setFiltros((prev) => ({ ...prev, estado: e.target.value }))}
            >
              <option value="all">Todos</option>
              {ESTADOS_FORMACION.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



